import * as angular from 'angular';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { EmbedActionType } from '@mode/reports/sandbox/contract';
import { NotebookVizRender } from '@mode/legacy/types-app-state';
import { EmbedReportState, ReportStore } from '@mode/reports/sandbox/contract';
import { MixableBaseController } from '../../../common/component';
import { EmbedNotebookSelectors, EmbedReportSelectors } from '../domain/embed-report.selectors';

import { tokenFromVizID } from '@mode/charts/domain';
import { isPresent } from '@mode/shared/util-js';
import ReportLinkService from '../../../services/report-link-service';
class ModeNotebookController extends MixableBaseController {
  static $inject = ['RxStoreService', 'ReportLinkService'];

  id: string;
  token: string;
  renderStartTime: number;

  dataset$: Observable<EmbedReportState.EmbedDataset>;
  view$: Observable<NotebookVizRender>;

  viewer$: Observable<string>;
  isVegasChart$: Observable<boolean>;
  isPivotTable$: Observable<boolean>;
  isBigNumber$: Observable<boolean>;
  title$: Observable<string>;

  constructor(
    private rxStore: ReportStore,
    private reportLinkService: ReportLinkService
  ) {
    super();
  }

  $onInit() {
    this.token = tokenFromVizID(this.id);
    this.view$ = this.rxStore.select(EmbedNotebookSelectors.createVizRenderSelector(this.token));
    this.title$ = this.view$.pipe(
      filter(isPresent),
      map((view) => view.title)
    );

    this.viewer$ = this.rxStore.select(EmbedReportSelectors.viewerType);
  }

  copySuccess() {
    this.rxStore.dispatch({
      type: EmbedActionType.ShowAlert,
      success: true,
      message: 'Link to output copied successfully',
    });
  }

  linkToLightbox() {
    if (this.reportLinkService.isLinkable()) {
      this.reportLinkService.linkToPage({ id: this.id }, 'lightbox');
    }
  }

  renderStart() {
    this.renderStartTime = performance.now();
  }

  renderEnd(visualizationRendered = true) {
    this.rxStore.dispatch({
      type: EmbedActionType.NotebookVisualizationRendered,
      token: this.token,
      visualizationRendered: visualizationRendered,
      duration: performance.now() - this.renderStartTime,
      timestamp: performance.now() + performance.timeOrigin,
      chartType: 'notebookViz',
    });
  }
}

export const ModeNotebookCellComponent: angular.IComponentOptions = {
  bindings: {
    id: '@',
  },
  controller: ModeNotebookController,
  controllerAs: 'ctrl',
  template: `<div class="editor-module editor-chart mode-object editor-multi">
    <div class="chart-content">
      <div class="chart-header">
        <in-place-edit text="ctrl.title$ | async:this" no-edit="true"></in-place-edit>
        <!-- Begin new report header -->
        <div class="new-viz-actions" ng-if="(ctrl.viewer$ | async:this) !== 'whiteLabel'">
          <copy-link-to-viz link="(ctrl.view$ | async:this).vizReportRunLink">
            <button
              class="new-viz-action hide-3"
              uib-tooltip="Get Share Link"
              copy-to-clipboard
              clipboard-enabled="isClipboardEnabled"
              clipboard-success="ctrl.copySuccess()"
              clipboard-text="(ctrl.view$ | async:this).vizReportRunLink"
              aria-label="Get Share Link">
              <svg-icon type="'copy-link'"></svg-icon>
            </button>
          </copy-link-to-viz>
          <div class="new-viz-actions__section" ng-if="!ctrl.viewer">
            <span class="divider"></span>
            <button class="new-viz-action"
              ng-click="ctrl.linkToLightbox($event)"
              aria-label="View Output">
              <svg-icon class="mode-hide-embed" type="'toggle-expanded-view'" uib-tooltip="View Output"></svg-icon>
              <svg-icon class="mode-show-embed-flex-inline" type="'toggle-expanded-view'" uib-tooltip="View Output in Mode" tooltip-placement="left"></svg-icon>
            </button>
          </div>
        </div>
        <!-- End new report header -->
      </div>
      </div>
      <div class="mode-notebook">
        <mode-notebook-cell-renderer
          ng-if="ctrl.view$ | async:this"
          [cell]="ctrl.view$ | async:this"
          on-render-start="ctrl.renderStart()"
          on-render-end="ctrl.renderEnd($event)"
        ></mode-notebook-cell-renderer>
      </div>
    </div>
  </div>
  `,
};
